import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';
import { animate, stagger, createScope, createSpring, createDraggable } from 'animejs';
import { useEffect, useRef, useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const hamburgerRef = useRef(null);
  const location = useLocation();

  const toggleMenu = () => {
    console.log('Menu toggled!');
    setIsOpen(!isOpen);
  };

  if (isOpen) {
    animate('.sidebar',{
      translateX: ['-100%', '0%'],
      duration: 100,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(1)', {
      rotate: 0,
        translateX: -100,
        duration: 300,
        easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(2)', {
      rotate: 0,
      translateX: -100,
      duration: 250,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(3)', {
      rotate: 0,
      translateX: -100,
      duration: 200,
      easing: 'easeOutQuad'
    });
    animate('.nav-link', {
      opacity: [0, 1],
      translateX: ['-20px', '0px'],
      delay: stagger(100),
      duration: 600,
      easing: 'easeOutQuad'
    });
  }
  else{
    animate('.sidebar',{
      translateX: ['0%', '-100%'],
      duration: 100,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(1)', {
      rotate: 0,
        translateX: 0,
        duration: 300,
        easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(2)', {
      rotate: 0,
      translateX: 0,
      duration: 250,
      easing: 'easeOutQuad'
    });
    animate('.hamburger-line:nth-child(3)', {
      rotate: 0,
      translateX: 0,
      duration: 200,
      easing: 'easeOutQuad'
    });
    animate('.nav-link', {
      rotate: 0,
      translateY: 0,
      duration: 400,
      easing: 'easeOutQuad'
    });
  }
  
  return (
    <>
      <div 
        className={`hamburger-menu ${isOpen ? 'open' : 'close'}`} 
        onClick={toggleMenu}
        ref={hamburgerRef}
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </div>
      
      <div 
        className={`sidebar ${isOpen ? 'open' : ''}`}
      >
        <div className="sidebar-header">
          <Link to="/" className="sidebar-brand">
            Brandon Mihalko
          </Link>
        </div>
        
        <Nav className="sidebar-nav flex-column">
          <Nav.Link 
            as={Link} 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-home"></i>
            <span>Home</span>
          </Nav.Link>
          <Nav.Link 
            as={Link} 
            to="/about" 
            className={location.pathname === '/about' ? 'active' : ''}
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-user"></i>
            <span>About</span>
          </Nav.Link>
          <Nav.Link 
            as={Link} 
            to="/projects" 
            className={location.pathname === '/projects' ? 'active' : ''}
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-code"></i>
            <span>Projects</span>
          </Nav.Link>
          <Nav.Link 
            as={Link} 
            to="/resume" 
            className={location.pathname === '/resume' ? 'active' : ''}
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-file-alt"></i>
            <span>Resume</span>
          </Nav.Link>
          <Nav.Link 
            as={Link} 
            to="/contact" 
            className={location.pathname === '/contact' ? 'active' : ''}
            onClick={() => setIsOpen(false)}
          >
            <i className="fas fa-envelope"></i>
            <span>Contact</span>
          </Nav.Link>
        </Nav>
        
        <div className="sidebar-footer">
          <a href="https://github.com/BMIHALKO" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/brandon-mihalko-a2a904271/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      </div>
      
      {/* Overlay to close menu when clicking outside */}
      {isOpen && <div className="sidebar-overlay" onClick={() => setIsOpen(false)}></div>}
    </>
  );
};

export default Navbar;